import { createHelpArticleSearch } from "@/lib/help-search";
import { INSPECTION_HELP_ARTICLES } from "@/lib/inspection-help/articles";

export const searchInspectionHelpArticles = createHelpArticleSearch(
  INSPECTION_HELP_ARTICLES,
);
